const production = {
    api: {
        enterprise: 'CGMP',
        baseUri: "https://api.pedagiodigital.com/webapi",
        baseUriAuth: "https://api.pedagiodigital.com",
        apiKeyAuth: "Frpurqt4j67ySKhMeiAZ4iZaL1RwY0b8b2uk3sFi",
        companyIdentification: "CGMP",
        channel: "17",
        automaticChannel: "17",
        userIdentification: "ffap",
        merchantDefinedInformation: {
            channel: "APP-RecargaPreManual"
        },
        cybersource: {
            orgId: "k8vif92e",
            merchantId: "semparar_br",
        },
        prefix: "ff-",
        hashKey: 'f5c5caf521f2f63230cf741b6dc1543c8ebb2881',
        loginVersion: "v1",
        app: 'PagueFF',
    },
    pci: {
        url: 'https://cyptgw.fleetcor.com.br',
        key: '99374fbe8588c6cb1fc1a04ccf0f38617ef72d3b2526393830a3dadd36462d87',
    },
}

export default production;